import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../rootReducer";
import { User } from "../../../@types/user";
import axiosInstance from "../../../utils/axiosConfig";

// El email ya no se envía aquí: su cambio pasa por `changeUserEmail` (permiso + sincronización con idok).
export const updateUser = createAsyncThunk(
  "userUpdate/updateUser",
  async (userFormData: User, { getState, rejectWithValue }) => {
    try {
      const state = getState() as RootState;
      const { name, dni } = userFormData;
      const { data } = await axiosInstance.patch(`${api.baseURL}user/${state.userUpdate.user.id}`, {
        name,
        dni,
      });
      return data as User;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
